import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../style/Home.css";
import "../style/HomeMobile.css";
import RequestQuoteForm from "./RequestQuoteForm";
import SEO from "./SEO";

const Home = ({ currentLanguage }) => {
  const [showQuoteModal, setShowQuoteModal] = useState(false);

  const translations = {
    EN: {
      slides: [
        {
          title: "Ride in Style",
          subtitle:
            "Premium Limo/Taxi Services Fleet Our premium Limo/taxi service fleet offers a luxurious and comfortable experience for all occasions.",
        },
        {
          title: "Cruise into Comfort",
          subtitle: "From cruises to parks to airports, our services are designed to make your vacation more enjoyable and stress-free.",
        },
      ],
      quoteMessage: "Need transportation to Orlando attractions?",
      requestQuote: "Request Quote",
    },
    AR: {
      slides: [
        {
          title: "ابحر في راحة تامة",
          subtitle:
            "من الرحلات البحرية إلى المنتزهات والمطارات، تم تصميم خدماتنا لجعل عطلتك أكثر متعة وخالية من التوتر.",
        },
        {
          title: "تنقل براحة تامة",
          subtitle: "أسطول خدمات التاكسي والليموزين الفاخرة.",
        },
      ],
      quoteMessage: "هل تحتاج إلى خطة سفر مخصصة؟ اطلب عرض أسعار مجاني اليوم!",
      requestQuote: "طلب عرض",
    },
    ES: {
      slides: [
        {
          title: "Navega con Total Comodidad",
          subtitle:
            "Desde cruceros hasta parques y aeropuertos, nuestros servicios están diseñados para que tus vacaciones sean más agradables y sin estrés.",
        },
        {
          title: "Viaja con Lujo",
          subtitle: "Flota de servicios premium de taxis y limusinas.",
        },
      ],
      quoteMessage:
        "¿Necesitas un plan de viaje personalizado?",
      requestQuote: "Solicitar Cotización",
    },
  };

  const { slides, quoteMessage, requestQuote } = translations[currentLanguage];

  const homeJsonLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Gators Transportation",
    "description": "Premium luxury transportation services featuring SUVs, sedans, sprinter vans, and stretch limousines.",
    "url": "https://gators-transportation-frontend-783a074757b1.herokuapp.com/",
    "logo": "https://gators-transportation-frontend-783a074757b1.herokuapp.com/images/logo.png",
    "sameAs": [],
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer service",
      "availableLanguage": ["English", "Spanish", "Arabic"]
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Transportation Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Luxury SUV Transportation",
            "description": "Premium SUV transportation for comfort and style"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Executive Sedan Service",
            "description": "Professional sedan transportation for business and personal use"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Sprinter Van Service",
            "description": "Group transportation with spacious sprinter vans"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Stretch Limousine Service",
            "description": "Luxury stretch limousine for special occasions"
          }
        }
      ]
    }
  };

  return (
    <>
      <SEO
        title="Gators Transportation | Premium Luxury Transportation Services"
        description="Premium transportation from MCO Airport to Disney World, Universal Studios, SeaWorld, Kissimmee Executive Airport. Professional chauffeur service for Orlando tourists and theme park visitors."
        keywords="Orlando International Airport transportation, MCO to Disney World, Universal Studios shuttle, SeaWorld Orlando transport, Kissimmee Executive Airport, Disney resort transportation, theme park transfers, Orlando tourist transportation, MCO airport taxi, Disney World shuttle"
        canonical="/"
        jsonLd={homeJsonLd}
      />
      
      {/* Desktop Layout */}
      <div className="modern-home-page">
        {/* Carousel Section */}
        <div id="mainCarousel" className="carousel slide modern-hero-carousel" data-bs-ride="carousel">
          <div className="carousel-inner">
            {slides.map((slide, index) => (
              <div
                key={index}
                className={`carousel-item modern-hero-item ${index === 0 ? "active" : ""}`}
              >
                <div className="hero-image-wrapper">
                  <img
                    src={`/images/${index + 1}.png`}
                    className="d-block w-100 hero-image"
                    alt={`Slide ${index + 1}`}
                  />
                  <div className="hero-gradient-overlay"></div>
                  <div className="hero-particles"></div>
                </div>
                <div className="carousel-caption modern-hero-caption">
                  <div className="hero-content-container">
                    <div className="hero-title-row">
                      <h1 className="hero-title single-line">{slide.title}</h1>
                    </div>
                    <div className="hero-subtitle-row">
                      <p className="hero-subtitle">{slide.subtitle}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          {/* Quote Overlay - Desktop Only */}
          <div className="modern-quote-overlay desktop-quote">
            <div className="quote-content-wrapper">
              <h2 className="modern-quote-title">{quoteMessage}</h2>
              <button
                className="btn modern-quote-btn text-uppercase fw-bold"
                onClick={() => setShowQuoteModal(true)}
              >
                <span className="btn-text">{requestQuote}</span>
                <div className="btn-shine"></div>
              </button>
            </div>
          </div>
          
          <button
            className="carousel-control-prev modern-hero-control prev-control"
            type="button"
            data-bs-target="#mainCarousel"
            data-bs-slide="prev"
          >
            <span className="hero-control-icon">‹</span>
          </button>
          <button
            className="carousel-control-next modern-hero-control next-control"
            type="button"
            data-bs-target="#mainCarousel"
            data-bs-slide="next"
          >
            <span className="hero-control-icon">›</span>
          </button>
        </div>

        {/* Mobile Quote Section - Outside Carousel */}
        <div className="mobile-quote-section">
          <div className="mobile-quote-container">
            <button
              className="btn mobile-quote-btn text-uppercase fw-bold"
              onClick={() => setShowQuoteModal(true)}
            >
              <i className="fas fa-quote-left me-2"></i>
              <span className="btn-text">{requestQuote}</span>
              <i className="fas fa-arrow-right ms-2"></i>
              <div className="btn-shine"></div>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Layout */}
      <div className="mobile-home-container">
        <div className="mobile-hero-section">
          <img
            src="/images/1.png"
            className="mobile-hero-image"
            alt="Gators Transportation"
          />
          <div className="mobile-hero-overlay"></div>
          <div className="mobile-floating-elements">
            <div className="floating-circle"></div>
            <div className="floating-circle"></div>
            <div className="floating-circle"></div>
          </div>
          <div className="mobile-hero-content">
            <h1 className="mobile-hero-title">{slides[0].title}</h1>
            <p className="mobile-hero-subtitle">{slides[0].subtitle}</p>
          </div>
        </div>
        
        <div className="mobile-quote-section-new">
          <div className="mobile-quote-container-new">
            <p className="mobile-quote-message">{quoteMessage}</p>
            <button
              className="mobile-quote-btn-new"
              onClick={() => setShowQuoteModal(true)}
            >
              {requestQuote}
            </button>
          </div>
        </div>
      </div>

      {showQuoteModal && (
        <RequestQuoteForm
          onClose={() => setShowQuoteModal(false)}
          currentLanguage={currentLanguage}
        />
      )}
    </>
  );
};

export default Home;